<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="cpaData ;  else loading" [formGroup]="cpaGroup" (ngSubmit)="onSubmit()">
    <div class="max-width-750">
      <h1 class="bofa--heading is-4">Consumer Privacy Act</h1>

      <div *ngFor="let verbiage of cpaData.cpaStateVerbiage">
        <div [innerHTML]="verbiage"></div>
        <mat-divider aria-hidden="true"></mat-divider>
      </div>

      <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the
        information above</p>

      <div class="marginbottom-margintop" *ngIf="cpaData">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)"></app-wet-signature>
        <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
      </div>

     <mat-checkbox aria-required="true" required (focusout)="legalOnBlur()" (focusin)="legalOnFocus()"
        formControlName="cpaLegalRequirementsMet" class="minor-check-padding">
        <mat-label class="white-space-normal"><abbr title="required">* </abbr> Yes, I agree that I have fully reviewed
          and completed the information above
        </mat-label>
      </mat-checkbox>
      <mat-error class="white-space-normal;"
        *ngIf="submit.value && cpaLegalRequirementsMet.hasError('required') && check"> Please
        check the box to agree to the above language
      </mat-error>

      <mat-form-field class="width350-margintop" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
        <input matInput placeholder="Full name" formControlName="cpaSignedName" required maxlength="250">
        <mat-error>Please enter a valid full name</mat-error>
      </mat-form-field>

      <mat-form-field class="width350">
        <mat-label>Date signed</mat-label>
        <input matInput value="{{ date }}" matInput disabled>
      </mat-form-field>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading CPA data...
</ng-template>
